<div [ngClass]="{'mox-ui-page-container': claim.isMox()}">
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
    <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p>{{ 'claimSection.deathAndSeriousBodyInjury.detailsOfAccident.title' | translate}}</p>
  </div>
  <BR>
  <div class="row col-12">
    <div class="col-xl-9 col-lg-12" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
      <form>
        <div class="form-group">
          <qnect-ui #PAT1_DATE_THE_ACCIDENT_OCCURRED [fieldId]="'PAT1_DATE_THE_ACCIDENT_OCCURRED'" [formGroup]="deTailOfAccidentForm" name="dateTheAccidentOccurred"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="!claim.getClaimTravel().getGBAPlanType()">
          <qnect-ui #PAT16_COUNTRY_OF_LOSS [fieldId]="'PAT16_COUNTRY_OF_LOSS'" [formGroup]="deTailOfAccidentForm" name="countryOfLoss" ></qnect-ui>
        </div>
        <div class="form-group" *ngIf="claim.getClaimTravel().getGBAPlanType()">
          <qnect-ui #GBA_PLACE_OF_LOSS [fieldId]="'GBA_PLACE_OF_LOSS'" [formGroup]="deTailOfAccidentForm" name="placeOfLoss"></qnect-ui>
        </div>
        <div class="form-group click-more-content" id="q1">
          <qnect-ui #PAT2_NATURE_OF_ILLNESS [fieldId]="'PAT2_NATURE_OF_ILLNESS'" [formGroup]="deTailOfAccidentForm" name="natureOfIllness"></qnect-ui>
        </div>
        <div class="form-group click-more-content" *ngIf="this.deathAndSeriousBodyInjuryLoss.getNatureOfIllness() =='Others'">
          <qnect-ui #PAT3_OTHER_TYPE_DESC [fieldId]="'PAT3_OTHER_TYPE_DESC'" [formGroup]="deTailOfAccidentForm" name="otherTypeDesc"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #PAT4_WAS_MUGGING [fieldId]="'PAT4_WAS_MUGGING'" [formGroup]="deTailOfAccidentForm" name="wasMugging"></qnect-ui>
        </div>
      </form>
    </div>
    <div class="col-xl-3 col-lg-12">
      &nbsp;
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" [hidden]="claim.isMox()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn btn-primary new-btn float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right" ></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>

<ng-template #not_covered_modal let-c="close" let-d="dismiss">
  <div class="modal-header" [ngClass]="{'mox-ui-popup-container-header mox-ui-popup-header-color': claim.isMox()}">
    <h4 class="modal-title" [ngClass]="{'mox-ui-font-size-20 mox-ui-padding-top-15': claim.isMox()}">{{deathAndSeriousBodyInjuryLoss.getNatureOfIllnessDesc()}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')" [ngClass]="{'mox-ui-opacity-1': claim.isMox()}" *ngIf="claim.isMox()">
      <span aria-hidden="true" *ngIf="!claim.isMox()">&times;</span>
      <div [ngClass]="{'mox-ui-popup-close mox-ui-popup-close-pos-relative mox-ui-popup-close-sm': claim.isMox()}">
          <span></span>
          <span></span>
          <span></span>
      </div>
    </button>
  </div>
  <div class="modal-body modal_contents" [ngClass]="{'mox-ui-popup-container-body mox-ui-popup-container-body-pd-btm-0 mox-ui-popup-container-body-pd-top-btm-26 mox-ui-popup-container-body-pd-border-btm mox-ui-font-size-14 text-left': claim.isMox()}">
    <p>{{'claimSection.deathAndSeriousBodyInjury.detailsOfAccident.majorBurnsNotCovered' | translate}}</p>
  </div>
  <div class="modal-footer" [ngClass]="{'mox-ui-popup-container-footer mox-ui-popup-container-footer-flex-wrap mox-ui-popup-footer-flex-space-between mox-ui-popup-container-footer-upload-pd': claim.isMox()}">
    <button type="button" class="btn btn-primary btn-modal" (click)="c('Close click')" [ngClass]="{'mox-ui-popup-container-footer-btn mox-ui-width-50per-20 mox-ui-popup-footer-close-btn-m-auto mox-ui-popup-mobile-footer-single-btn-width': claim.isMox()}">
      {{'claimSection.generalLabels.generalButtonLabels.ok' | translate}}
    </button>
  </div>
</ng-template>